import { render, staticRenderFns } from "./TdRoute.vue?vue&type=template&id=3ec0b46c&"
import script from "./TdRoute.vue?vue&type=script&lang=ts&"
export * from "./TdRoute.vue?vue&type=script&lang=ts&"
import style0 from "./TdRoute.vue?vue&type=style&index=0&id=3ec0b46c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports